import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import MyOfficeAssignmentDetailItem from '../../../../Domain/MyOfficeAssignmentDetailItem';
import AssignmentService from '../../../../Services/AssignmentService';
import MyOfficeAssignmentSummarySearchParams from './MyOfficeAssignmentSummarySearchParams';

export default class MyOfficeAssignmentDetailAdmin extends React.Component {
  static defaultProps = {
    completedDate: '',
    officeId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new MyOfficeAssignmentSummarySearchParams(),
    };
    this.state.searchItem.CompletedDate = this.props.completedDate;
    this.state.searchItem.OfficeId = this.props.officeId;
    this.startSearch = this.startSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props != prevProps) {
      this.setState({
        searchItem: {
          ...this.state.searchItem,
          CompletedDate: this.props.completedDate,
          OfficeId: this.props.officeId,
        },
      });
    }
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={MyOfficeAssignmentDetailItem}
          serviceFunction={AssignmentService.GetMyOfficeAssignmentDetailsBySearching}
          convertDBItemsFunction={AssignmentService.ConvertMyOfficeAssignmentDetailDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={MyOfficeAssignmentSummarySearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          errorCode='MOADA40'
        />
      </div>
    );
  }
}
